<template>
  <img
    src="../../assets/img-v2/ic_mine.png"
    alt="个人中心"
    class="user-center"
    @click="onUserTriggerClick"
  />
</template>

<script>
export default {
  name: "userCenterTrigger",
  methods: {
    onUserTriggerClick() {
      this.$UserService.turnToUserView();
    },
  },
};
</script>

<style scoped>
.user-center {
  width: 36px;
  height: 44px;
}
</style>
